var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNexford(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 128 53",
    height: "68px",
    width: "178px",
    viewBox: "0 0 128 53",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m22.2 1v45.5c0 .6-.5 1.1-1.1 1.1h-4.1c-.6 0-1.1-.5-1.1-1.1v-40.2c0-2.9-2.4-5.3-5.3-5.3h-4.2c-2.9 0-5.3 2.4-5.3 5.3v45.4h4.2v-45.4c0-.6.5-1.1 1.1-1.1h4.2c.6 0 1.1.5 1.1 1.1v40.1c0 2.9 2.4 5.3 5.3 5.3h4.2c2.9 0 5.3-2.4 5.3-5.3v-45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.1 25.6v-14.7h2.3l6.6 10.3c.3.5.5.9.6 1.1v-11.4h2.2v14.7h-2.3l-6.5-10.3c-.3-.5-.5-.9-.6-1.1v11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.9 15.1 2 3.2 2.1-3.2h2.5l-3.3 4.9 3.6 5.6h-2.5l-2.4-3.9-2.4 3.9h-2.5l3.8-5.6-3.3-4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.4 23.9c.9 0 1.7-.3 2.4-1s1-1.5 1-2.5-.3-1.9-1-2.5c-.7-.7-1.5-1-2.4-1s-1.7.3-2.4 1-1 1.5-1 2.5.3 1.9 1 2.5c.6.7 1.4 1 2.4 1m5.5-3.5c0 1.7-.5 3-1.7 4-1.1 1-2.4 1.5-3.9 1.5s-2.8-.5-3.9-1.5-1.7-2.3-1.7-4 .6-3 1.7-4 2.4-1.5 3.9-1.5 2.8.5 3.9 1.5c1.2.9 1.7 2.3 1.7 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.5 16.9v-1.7h-2.1v10.4h2.1v-5.5c0-1.9.9-3.1 3.4-3v-2c-1.8 0-3 .5-3.4 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.5 33.4v-1.7h-2.1v10.4h2.1v-5.5c0-1.9.9-3.1 3.4-3v-2c-1.7 0-2.9.5-3.4 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.6 23.9c.9 0 1.7-.3 2.3-1s.9-1.5.9-2.5-.3-1.9-.9-2.5c-.6-.7-1.4-1-2.3-1s-1.7.3-2.3 1-.9 1.5-.9 2.5.3 1.9.9 2.5c.6.7 1.4 1 2.3 1m5.2-13v14.7h-2.1v-1.7c-.8 1.3-1.9 2-3.4 2s-2.7-.5-3.6-1.5c-1-1-1.5-2.3-1.5-4 0-1.6.5-2.9 1.5-4 1-1 2.2-1.5 3.5-1.5 1.7 0 2.8.6 3.5 1.9v-5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.9 27.4v9.5c0 1.7-.4 3.1-1.5 4.1s-2.7 1.5-4.4 1.5-3.3-.5-4.4-1.5-1.5-2.3-1.5-4.1v-9.5h2.2v9.4c0 2.1 1.5 3.5 3.7 3.5s3.7-1.4 3.7-3.5v-9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.1 42.1h-2.1v-6.5c0-1.3-.5-2.2-2.1-2.2-1.5 0-2.9 1.5-2.9 3.4v5.3h-2.1v-10.5h2.1v1.8c.7-1.4 2.1-2.1 3.6-2.1 2 0 3.6 1.5 3.6 3.7v7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.2 31.6h2.2v10.5h-2.2v-5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.2 31.6-4.2 10.5h-2l-4.2-10.5h2.3l2.9 7.8 2.9-7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.7 31.6h2.1v10.5h-2.1v-5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.4 40c-.3 0-.5-.3-.5-.6v-5.9h2.6v-1.8h-2.6v-4.1h-2.1v4.1h-1.5v1.8h1.5v5.9c0 1.5 1.2 2.7 2.7 2.7h2.1v-2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.5 12.9h2.1v-2.1h-2.1c-1.5 0-2.7 1.2-2.7 2.7v1.6h-1.5v1.9h1.5v8.4.2h2.1v-.2-8.4h2.6v-1.8h-2.6v-1.6c0-.4.3-.7.6-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.2 29.9h2.2v-2.3h-2.2v1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.7 29.9h2.1v-2.3h-2.1v1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m125.6 31.6-2.9 7.5-2.9-7.5h-2.5l4.2 10.5-.5 1.2c-.5 1.2-.9 1.2-2.4 1.2v2h1.4c1.3 0 2.3-.8 2.9-2.3l5-12.5h-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.9 20.1c0-1.5-.5-2.8-1.4-3.8s-2.2-1.5-3.7-1.5-2.8.5-3.8 1.6c-1 1-1.6 2.4-1.6 4s.5 2.9 1.5 4c1 1 2.3 1.6 3.7 1.6 2.2 0 4.1-1.2 5-3.4h-2.2c-.6 1-1.4 1.5-2.8 1.5-1.8 0-3.1-1.3-3.2-3.2h8.3v-.8zm-8.3-.9c.2-.8.6-1.4 1.2-1.9 1.1-1 2.9-.9 4 0 .6.5.9 1.1 1 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.9 36.6c0-1.5-.5-2.8-1.4-3.8s-2.2-1.5-3.7-1.5-2.8.5-3.8 1.6c-1 1-1.6 2.4-1.6 4s.5 2.9 1.5 4c1 1 2.3 1.6 3.7 1.6 2.2 0 4.1-1.2 5-3.4h-2.2c-.6 1-1.4 1.5-2.8 1.5-1.8 0-3.1-1.3-3.2-3.2h8.3v-.8zm-8.3-.9c.2-.8.6-1.4 1.2-1.9 1.1-1 2.9-.9 4 0 .6.5.9 1.1 1 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.6 31.4c-1 0-1.9.3-2.6.8s-1.1 1.2-1.1 2.1c0 1.6 1.2 2.7 3.6 3.2 1.7.3 2.5.8 2.5 1.6 0 .9-.9 1.5-2 1.5-1.2 0-2-.6-2.5-1.6h-2.1c.4 2.1 2.2 3.4 4.5 3.4 2.5 0 4-1.5 4-3.4 0-1.7-1.1-2.7-3.5-3.2-1.7-.3-2.6-.8-2.6-1.7 0-.7.8-1.2 1.8-1.2 1.1 0 2.1.5 2.2 1.5h1.9c0-2-2-3-4.1-3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNexford);
export default __webpack_public_path__ + "static/media/nexford.2b241ed15fde7cba436c27f4522f85dc.svg";
export { ForwardRef as ReactComponent };